
import { LoadCategories } from '../../../util/Enum';
import { LoadCategoriesDropdown } from '../../../util/Enum';
export default {
  props: {
    filterProp: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      LoadCategories,
      selectedCategories: []
    };
  },
  watch: {
    filterProp: {
      handler() {
        if (this.filterProp !== null) {
            this.selectedCategories = this.filterProp
        } else {
          this.selectedCategories = []
        }
        this.$emit('value-changed', this.selectedCategories)

      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleChange () {
      this.$emit('value-changed', this.selectedCategories)
      
    },
    getFormattedName(name){
      if(name.length > 13) {
         return name.slice(0,12)+ '...';
      }
      return name;
   }
  }
}
